import { Component } from "@angular/core"
import { AlertController, LoadingController, NavController } from "ionic-angular"
import firebase from "firebase"

import { EventService } from "../../services/event"
import { EventsListPage } from "../events/list"

@Component({
  selector: "home-page",
  templateUrl: "index.html"
})
export class HomePage {

  eventsWaiting = []
  eventsExchange = []
  eventsRelease = []
  isLoading = true

  constructor(
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private loadingCtrl: LoadingController
  ) {}

  ionViewDidEnter() {

    this.loadEvents()
  }

  loadEvents() {

    const loading = this.loadingCtrl.create({ content: "Obtendo eventos..." })

    loading.present()

    this.isLoading = true
    this.eventsWaiting = []
    this.eventsExchange = []
    this.eventsRelease = []

    EventService.getEvents("pending")
      .then((events) => {

        events.forEach((event) => {

          if (event.type == "empty")
            return

          if (event.status == "waiting_confirmation") {

            this.eventsWaiting.push(event)

          } else if (event.status == "exchange_requested") {

            this.eventsExchange.push(event)

          } else if (event.status == "released") {

            this.eventsRelease.push(event)
          }
        })

        loading.dismiss()

        this.isLoading = false
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.isLoading = false

        this.alertCtrl.create({
          message: "Falha ao obter eventos",
          buttons: ["Ok"]
        }).present()
      })
  }

  hasEvents() {

    return (this.hasEventsWaiting() || this.hasEventsRelease() || this.hasEventsExchange())
  }

  hasEventsWaiting() {

    return (this.eventsWaiting.length > 0)
  }

  hasEventsExchange() {

    return (this.eventsExchange.length > 0)
  }

  hasEventsRelease() {

    return (this.eventsRelease.length > 0)
  }

  showEventsWaiting() {

    this.navCtrl.push(EventsListPage, { action: "confirm", events: this.eventsWaiting })
  }

  showEventsExchange() {

    this.navCtrl.push(EventsListPage, { action: "exchange", events: this.eventsExchange })
  }

  showEventsRelease() {

    this.navCtrl.push(EventsListPage, { action: "release", events: this.eventsRelease })
  }

  isLoggedUserEvent(event) {

    const loggedUser = firebase.auth().currentUser

    return (event.user && (event.user.email == loggedUser.email || event.user.uid == loggedUser.uid))
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/index.ts